import { SearchLeiCode } from "../api/services/search-lei";

export const transformLei = (data: any[]) => {
    const lei =  data.map((el:any) => ({
        lei: el.attributes.lei,
        status: el.attributes.registration.status,
        date: el.attributes.registration.nextRenewalDate,
        name: el.attributes.entity.legalName.name,
        country: el.attributes.entity.jurisdiction
    }))
    return lei
}

// GLEIF's autocomplete index alone misses plenty of real matches (typos,
// partial LEI codes, names it hasn't indexed as a prefix) - falls through
// fuzzy matching, then exact filters, same chain leiprofile.com's search
// uses. Shared by every page that offers a free-text LEI search.
export const searchGleifLei = async (query: string): Promise<ReturnType<typeof transformLei>> => {
    const autoRes = await SearchLeiCode.searchLei(query);
    let completions = autoRes.data.data;

    if (!completions || completions.length === 0) {
        const fuzzyRes = await SearchLeiCode.searchLeiFuzzy(query);
        completions = fuzzyRes.data.data;
    }

    const leiIds = (completions || [])
        .filter((el: any) => el.relationships)
        .map((el: any) => el.relationships["lei-records"].data.id);

    if (leiIds.length > 0) {
        const details = await Promise.all(leiIds.map((id: string) => SearchLeiCode.getLei(id)));
        return transformLei(details.map((el: any) => el.data.data));
    }

    const byLei = await SearchLeiCode.searchLeiRecordsByLei(query);
    if (byLei.data.data.length > 0) {
        return transformLei(byLei.data.data);
    }

    const byName = await SearchLeiCode.searchLeiRecordsByName(query);
    return transformLei(byName.data.data);
}